<template>
    <div>
        <div class="row pb-3">
            <div class="col-sm-12">
                <h4 class="font-weight-bold">Pendência e Ocorrência</h4>
            </div>
            <div class="col-md-12">
                <table class="table table-bordered">
                    <tbody>
                        <tr
                            v-for="item in $root.arrays.pendencias_usuarios"
                            :key="item.id"
                        >
                            <td
                                :class="
                                    checkPendencias(item.id) ? 'bg-danger' : ''
                                "
                            >
                                {{ item.value }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            pendencias: {
                ind_ptab_desat_inep_memb: null,
                ind_pmig_cpo_obr_memb: null,
                ind_pmig_sem_doc_memb: null,
                ind_pmig_rf_cpf_eleitor_memb: null,
                ind_pmig_rf_cpf_inv_memb: null,
                ind_pmig_rf_cpf_mult_memb: null,
                ind_pmig_memb_cpf_mult_memb: null,
                ind_pmig_rf_cpf_titular_memb: null,
                ind_pmig_memb_cpf_titular_memb: null,
                ind_pmig_rf_eleitor_inv_memb: null,
                ind_pmig_rf_eleitor_mult_memb: null,
                ind_pmig_memb_cpf_inv_memb: null,
                ind_pmig_memb_eleitor_mult_memb: null,
                ind_pmig_rf_idade_16_memb: null,
                ind_ptrn_memb_inep_memb: null,
                ind_ptrn_memb_parente_memb: null,
                ind_paud_cpo_obr_memb: null,
                ind_paud_rf_cpf_eleitor_memb: null,
                ind_paud_rf_cpf_inv_memb: null,
                ind_paud_rf_cpf_mult_memb: null,
                ind_paud_memb_cpf_mult_memb: null,
                ind_paud_rf_cpf_titular_memb: null,
                ind_paud_memb_cpf_titular_memb: null,
                ind_paud_memb_cpf_inv_memb: null,
                ind_paud_memb_eleitor_inv_memb: null,
                ind_paud_rf_eleitor_inv_memb: null,
                ind_paud_memb_eleitor_mult_memb: null,
                ind_paud_rf_idade_16_memb: null,
                ind_paud_rejei_memb: null,
                ind_otrn_outro_mun_pes: null,
                ind_otrn_nova_pes: null,
                ind_otrn_exist_pes: null,
                ind_otrn_outra_pes: null,
                ind_osrg_sem_certidao_pes: null,
                ind_osrg_sem_registro_pes: null,
                ind_osrg_nao_sabe_pes: null,
                ind_paud_mbo_cad_com_cert_obit: null,
            },
        };
    },
    mounted() {
        if (this.item.pendencias != null) {
            this.pendencias = this.item.pendencias;
        }
    },
    methods: {
        checkPendencias(pendencia) {
            if (this.item.pendencias) {
                return this.item.pendencias[pendencia] ? true : false;
            } else {
                return false;
            }
        },
        submit() {
            this.item.pendencias = this.pendencias;
            this.$emit("submit");
        },
    },
};
</script>
<style lang="css">
.bg-danger {
    background: #fb8994 !important;
    color: #424242 !important;
}
</style>
